export default __webpack_public_path__ + "static/icon-computer-161fc8126ae6e1e1ab7d2f81a0c57ee2.svg";